<template>
    <a-drawer :title="titleF" :closable="false" :width="720" @close="onClose" :visible="visibleEdit">
        <a-form :form="form" layout="vertical" hideRequiredMark>
            <a-form-item label="修改项">
                <a-select v-decorator="['value']" style="width:100%"
                    @change="handleChange1" placeholder="请选择修改项">
                    <a-select-option v-for="(item,index) in selectList" :key="index">{{ item }}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="层数" v-if="value==0">
                <a-input v-decorator="['layer', { rules: [{ required: true, message: '请输入层数' }] }]" style="width: 100%"
                    placeholder="请输入层数" />
            </a-form-item>
            <!-- <a-form-item label="上次维修时间" v-if="value==1">
                <a-date-picker v-decorator="['lastmaint', { rules: [{ required: true, message: '请选择上次维修时间' }] }]"
                    placeholder="请选择上次维修时间" />
            </a-form-item> -->
            <a-form-item label="上次维保时间" v-if="value==1">
                <a-date-picker v-decorator="['checkTime', { rules: [{ required: true, message: '请选择上次维保时间' }] }]"
                    placeholder="请选择上次维保时间" />
            </a-form-item>
            <a-form-item label="安装时间" v-if="value==2">
                <a-date-picker v-decorator="['instime', { rules: [{ required: true, message: '请选择安装时间' }] }]"
                    placeholder="请选择安装时间" />
            </a-form-item>
            <a-form-item label="状态" v-if="value==3">
                <a-select v-decorator="['status']" style="width: 100%"
                    placeholder="请选择状态">
                    <a-select-option v-for="item in statusArr" :key="item.keyStr" :value="item.keyStr">
                      {{ item.value }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="每组数量" v-if="value==4">
               <a-input-number :min="1" v-decorator="['groupNum', { rules: [{ required: true, message: '请输入每组数量' }] }]" style="width: 100%"
                   placeholder="请输入每组数量" />
            </a-form-item>
            <a-form-item label="二维码编号" v-if="value==5">
              <a-input v-decorator="['qrcode']" placeholder="请输入二维码编号" />
            </a-form-item>
        </a-form>
        <div :style="{ position: 'absolute', left: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right' }">
            <a-button :style="{ marginRight: '8px' }" @click="onClose">取消</a-button>
            <a-button @click="submit" type="primary">提交</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            visibleEdit: {
                //新增抽屉是否可见
                default: false
            },
            statusArr:Array
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: [],
                selectList: ['层数','上次维保时间','安装时间','状态','数量','二维码编号'],
                value:0,//修改项
                titleF: '批量修改' //抽屉标题

            };
        },
        mounted() {
        },
        methods: {
            init() {
                //初始化表格
                this.form.resetFields();
                this.titleF = '新增消防设施';
            },
            handleChange1(value) {
            	this.value=value;
            },
            onChange(date, dateString) {
                // console.log(date, dateString);
            },
            submit() {
                this.form.validateFields((err, values) => {
                  values.ids = this.id
				  console.log(values);
                    if (!err) {
                        this.$post('facility/batchUpdate', { ...values}).then(r => {
                            this.reset();
                            this.$message.success('操作成功');
                            this.$emit('success');
                            this.onClose();
                        });
                    }
                });
            },
            setFormValues(id){
              this.id = id
            },
            onClose() {
                // this.visibleEdit = false;
                this.$emit('close'); //不要直接更改visibleEdit
                this.form = this.$form.createForm(this);
				this.value = null;
                this.loading = false;
            },
            //重置
            reset() {
                form: this.$form.createForm(this);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/web/firefacility/FireFacilityEdit.vue